import controller from './change-password.controller';

function RouteConfig($stateProvider) {
	'ngInject';

	$stateProvider
		.state('app.private.agents.changePassword', {
			controller,
			template: `<div ng-include="'partials/change-password.html'"></div>`,
			'url': '/change-password/:id',
			'controllerAs': 'vm',
			'params': {
				'page': 1,
				'comeFrom': 'list'
			},
			'resolve': {
				'userId': function($stateParams) {
					'ngInject';

					return $stateParams.id;
				}
			}
		});
}

export default RouteConfig;




/** WEBPACK FOOTER **
 ** ./client/private/agents/change-password/change-password.route.js
 **/